/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export const SET_SYSTEM_HEALTH_INTERVAL = 'SET_SYSTEM_HEALTH_INTERVAL';
export const CLEAR_SYSTEM_HEALTH_INTERVAL = 'CLEAR_SYSTEM_HEALTH_INTERVAL';
